import { Component, Inject, Input, ChangeDetectionStrategy } from '@angular/core';
import { RbacServiceInterface } from '../../../../services/rbac/rbac-service.interface';
import { RbacPermissionsConstant } from '../../../../services/rbac/rbac-permissions.constant';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'gtd-ui-field-default-link',
  templateUrl: './link.component.html',
})
export class LinkComponent {
  @Input() link: string | string[];
  @Input() displayData: any;
  @Input() relationData: any;
  @Input() rbacProperty: string;
  @Input() customClass = 'c-link c-link--primary -blue';
  public RbacPermissionsConstant = RbacPermissionsConstant;

  constructor(@Inject('RbacServiceInterface') public rbacService: RbacServiceInterface) {}
}
